<template>
    <v-container class="py-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn v-if="page.isNew" id="btnSave" type="submit" elevation="0" color="primary" dark
                            :loading="dataset.loading" @click="add">Salvar</v-btn>
                        <v-btn v-else id="btnSave" type="submit" elevation="0" color="primary" dark
                            :loading="dataset.loading" @click="update">Salvar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" outlined color="primary"
                            @click="goBack">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="form-card">
                    <v-card-text>
                        <v-form ref="form" @submit.prevent="save">
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field v-model="dataset.data.name" label="Nome Completo"
                                        :rules="[rules.required]" outlined dense hide-details="auto"
                                        :disabled="!page.isNew && (!($check(['admins.update'])))"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-select dense id="type" :items="dataset.roles" label="Cargo"
                                        v-model="dataset.data.role_id" item-value="id" item-text="name" outlined
                                        hide-details="auto"
                                        :disabled="!page.isNew && (!($check(['admins.update'])))"></v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field v-model="dataset.data.email" label="Email"
                                        :rules="[rules.required, rules.email]" outlined dense hide-details="auto"
                                        :disabled="!page.isNew && (!($check(['admins.update'])))"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
</template>

<script>
import axios from 'axios';
import string from "@/common/util/string";

export default {
    name: 'AdminDetails',
    data: () => ({
        dataset: {
            data: {},
            roles: []
        },
        page: {
            isNew: false,
            title: ''
        },
        loading: false,
        rules: {
            required: value => !!value || 'Campo obrigatório.',
            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || 'Email inválido.';
            },
        },
    }),

    computed: {
        breadcrumbItems() {
            const items = [
                { text: 'Home', disabled: false, to: '/home', exact: true },
                { text: 'Administradores', disabled: false, to: '/administradores', exact: true },
            ];

            items.push({
                text: !this.page.isNew ? 'Editar' : 'Incluir',
                disabled: true,
                exact: true,
            });
            return items;
        },
    },

    created() {
        this.setPage();
        this.load();
        this.loadRoles();
    },

    methods: {
        setPage() {
            this.page.isNew = this.$route.params.id == 'novo';

            this.page.title = !this.page.isNew ? 'Editar' : 'Incluir';
        },

        async load() {
            if (this.page.isNew) return;

            this.loading = true;

            try {
                const response = await axios.get(`/api/v2/admins/${this.$route.params.id}`);
                this.dataset.data = response.data.content;
            } catch (error) {
                console.error('Erro ao carregar detalhes do administrador:', error.response || error);
                this.$dialog.notify.error(this.$codes(error) || 'Erro ao carregar detalhes do administrador.', { position: 'top-right', timeout: 5000 });
                this.goBack();
            } finally {
                this.loading = false;
            }
        },

        async add() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja salvar o administrador?',
                title: 'Administrador',
                actions: {
                    false: 'Cancelar',
                    true: 'Salvar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            const payload = this.buildPayload();

            try {
                await axios.post(`/api/v2/admins`, payload, { config: { headers: { "Content-Type": "application/json" } } });

                this.$dialog.notify.info("Admin salvo com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async loadRoles() {
            try {
                const response = await axios.get('/api/v2/roles', { params: { limit: 10000 } });

                this.dataset.roles = response.data.data
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar o administrador?',
                title: 'Administrador',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            const payload = this.buildPayload();

            try {
                await axios.patch(`/api/v2/admins/${this.$route.params.id}`, payload, { config: { headers: { "Content-Type": "application/json" } } });

                this.$dialog.notify.info("Administrador salvo com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        buildPayload() {
            const data = {
                name: this.dataset.data.name,
                email: this.dataset.data.email,
                role_id: this.dataset.data.role_id
            }

            return data;
        },

        goBack() {
            this.$router.push('/administradores');
        },
    },
};
</script>
